/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetOrganizationContinuousClusterBackups = {
  id: 'organization-continuous-cluster-backups.get',
  tag: 'Cluster',
  summary: 'Get continuous cluster backup statuses within an organization',
  description: 'Retrieves all clusters within the organization, and whether they currently posses a continuous backup.',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/backup/continuous/existence`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              projectId: ZodTypes.Id,
              clusterId: ZodTypes.Id,
              hasContinuousBackups: z.boolean(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
